import { render, staticRenderFns } from "./AddonPromo.vue?vue&type=template&id=5230197e&"
import script from "./AddonPromo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AddonPromo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports